export default __webpack_public_path__ + "static/media/no-mistakes-illustration-main.9f895130.svg";